var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content new-booking"},[(_vm.checkoutUrl)?_c('iframe',{attrs:{"src":_vm.checkoutUrl,"scrolling":"auto","id":"new-booking-iframe","width":"100%","height":"100%"}}):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f37d273","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/booking-new/bookingNew.vue
// module id = 756
// module chunks = 2